export default "__VITE_ASSET__5ded1ea3__"